/* FAKI PERFUMES — SHOPIFY CART + MODAL */
var C={keys:[],data:{items:[],item_count:0,total_price:0}};

/* ── CART OPEN/CLOSE ── */
function openCart(){
  fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(d){
    C.data=d;C.keys=d.items.map(function(i){return i.key;});
    badge(d.item_count);draw(d);
  });
  document.getElementById('cartOverlay').classList.add('open');
  document.getElementById('cartDrawer').classList.add('open');
  document.body.style.overflow='hidden';
}
function closeCart(){
  document.getElementById('cartOverlay').classList.remove('open');
  document.getElementById('cartDrawer').classList.remove('open');
  document.body.style.overflow='';
}

/* ── BADGE ── */
function badge(n){
  var el=document.getElementById('cartBadge');
  if(!el)return;
  el.textContent=n;
  el.classList.toggle('on',n>0);
}

/* ── ADD TO CART ── */
function addItem(variantId,title,btn){
  if(btn){btn.textContent='...';btn.disabled=true;}
  fetch('/cart/add.js',{
    method:'POST',credentials:'same-origin',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({id:parseInt(variantId),quantity:1})
  })
  .then(function(r){if(!r.ok)throw r.status;return r.json();})
  .then(function(item){
    if(btn){btn.textContent='Add to Cart';btn.disabled=false;}
    showNotif((title||item.title)+' added to cart');
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(d){
      C.data=d;C.keys=d.items.map(function(i){return i.key;});badge(d.item_count);draw(d);
    });
    openCart();
  })
  .catch(function(e){
    console.error('addItem failed:',e);
    if(btn){btn.textContent='Add to Cart';btn.disabled=false;}
    showNotif('Could not add item. Please try again.');
  });
}

/* ── DRAW DRAWER ── */
function draw(d){
  var body=document.getElementById('cartBody');
  var foot=document.getElementById('cartFoot');
  if(!body)return;
  if(!d||d.item_count===0){
    body.innerHTML='<div class="cart-empty-msg"><span>&#128717;</span><p>Your cart is empty</p></div>';
    if(foot)foot.style.display='none';
    return;
  }
  if(foot)foot.style.display='block';
  C.keys=d.items.map(function(i){return i.key;});
  body.innerHTML=d.items.map(function(item,idx){
    var img=item.image?'<img src="'+item.image+'" alt="">':'<div class="ci-no-img">&#127757;</div>';
    var vt=(item.variant_title&&item.variant_title!=='Default Title')?'<div class="ci-meta">'+item.variant_title+'</div>':'';
    return'<div class="ci">'+img+'<div class="ci-info"><div class="ci-name">'+item.product_title+'</div>'+vt+'<div class="ci-price">'+(item.price/100).toFixed(0)+' QAR</div><div class="ci-qty"><button class="qbtn" data-i="'+idx+'" data-d="-1" onclick="chQty(this)">&#8722;</button><span style="font-size:0.82rem;min-width:20px;text-align:center">'+item.quantity+'</span><button class="qbtn" data-i="'+idx+'" data-d="1" onclick="chQty(this)">+</button></div><button class="ci-remove" data-i="'+idx+'" onclick="rmItem(this)">Remove</button></div></div>';
  }).join('');
  var t=document.getElementById('cartTotalVal');
  if(t)t.textContent=(d.total_price/100).toFixed(0)+' QAR';
}

/* ── QTY / REMOVE ── */
function chQty(btn){
  var idx=parseInt(btn.dataset.i),d=parseInt(btn.dataset.d);
  var key=C.keys[idx],cur=C.data.items[idx]?C.data.items[idx].quantity:1;
  fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,cur+d)})})
    .then(function(r){return r.json();}).then(function(c){C.data=c;C.keys=c.items.map(function(i){return i.key;});badge(c.item_count);draw(c);});
}
function rmItem(btn){
  var key=C.keys[parseInt(btn.dataset.i)];
  fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})})
    .then(function(r){return r.json();}).then(function(c){C.data=c;C.keys=c.items.map(function(i){return i.key;});badge(c.item_count);draw(c);});
}

/* ── WHATSAPP ORDER ── */
function waOrder(){
  fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(d){
    if(!d||d.item_count===0)return;
    var lines=d.items.map(function(i){return encodeURIComponent(i.product_title)+' x'+i.quantity+' - '+(i.line_price/100).toFixed(0)+' QAR';}).join('%0A');
    var total=(d.total_price/100).toFixed(0);
    window.open('https://wa.me/97439999004?text=New Order:%0A'+lines+'%0ATotal: '+total+' QAR','_blank');
  });
}

/* ── QUICK VIEW (same as reference modal) ── */
var QV={vid:null,title:''};
function openQV(name,imgUrl,ptype,price,variantId,productUrl,wa){
  QV.vid=variantId;QV.title=name;
  var i=document.getElementById('qvImg');
  if(i){i.src=imgUrl||'';i.style.display=imgUrl?'block':'none';}
  var n=document.getElementById('qvName');if(n)n.textContent=name;
  var t=document.getElementById('qvType');if(t)t.textContent=ptype;
  var p=document.getElementById('qvPrice');if(p)p.textContent=price+' QAR';
  var vb=document.getElementById('qvView');if(vb)vb.href=productUrl;
  var wb=document.getElementById('qvWA');if(wb)wb.href='https://wa.me/97439999004?text=Order: '+wa;
  var ov=document.getElementById('qvOverlay');
  if(ov){ov.classList.add('active');document.body.style.overflow='hidden';}
}
function closeQV(){
  var ov=document.getElementById('qvOverlay');
  if(ov){ov.classList.remove('active');document.body.style.overflow='';}
}
function qvAdd(){
  if(!QV.vid)return;
  var btn=document.getElementById('qvAddBtn');
  if(btn){btn.textContent='Adding...';btn.disabled=true;}
  fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({id:parseInt(QV.vid),quantity:1})})
    .then(function(r){return r.json();})
    .then(function(item){
      fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(d){
        C.data=d;C.keys=d.items.map(function(i){return i.key;});badge(d.item_count);draw(d);
      });
      closeQV();openCart();
      showNotif(QV.title+' added to cart');
      if(btn){btn.textContent='Add to Cart';btn.disabled=false;}
    })
    .catch(function(){if(btn){btn.textContent='Add to Cart';btn.disabled=false;}});
}

/* ── NOTIFICATION ── */
function showNotif(msg){
  var n=document.getElementById('siteNotif');
  if(!n)return;
  n.textContent=msg;n.classList.add('show');
  setTimeout(function(){n.classList.remove('show');},2500);
}

/* ── INIT ── */
document.addEventListener('DOMContentLoaded',function(){
  fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(d){badge(d.item_count);});
  var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting)e.target.classList.add('visible');});},{threshold:0.1});
  document.querySelectorAll('.fade-in').forEach(function(el){obs.observe(el);});
});
